{
  document.querySelectorAll('.accordion-component--toggle-all').forEach(toggleAllButton => {
    toggleAllButton.addEventListener('click', e => {
      const container = toggleAllButton.closest(".accordion-component")
      const ariaTextContainer = container.querySelector(".accordion-component--sr-text")
      if(container){
        if(toggleAllButton.textContent == toggleAllButton.getAttribute('data-label-open')){
          toggleAllButton.textContent = toggleAllButton.getAttribute('data-label-close')
          ariaTextContainer.textContent = ariaTextContainer.getAttribute('data-label-open')
          container.querySelectorAll('button[is="ada-toggler"][aria-expanded="false"]').forEach(toggler => {
            toggler._onTogglerClick(false)
          })
        } else {
          toggleAllButton.textContent = toggleAllButton.getAttribute('data-label-open')
          ariaTextContainer.textContent = ariaTextContainer.getAttribute('data-label-close')
          container.querySelectorAll('button[is="ada-toggler"][aria-expanded="true"]').forEach(toggler => {
            toggler._onTogglerClick(false)
          })
        }
      } 
    })
  })
}